/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface OsisRuleListItem
 */
export interface OsisRuleListItem {
    /**
     * 
     * @type {string}
     * @memberof OsisRuleListItem
     */
    id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OsisRuleListItem
     */
    state?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof OsisRuleListItem
     */
    description?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof OsisRuleListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof OsisRuleListItem
     */
    readonly marketingCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OsisRuleListItem
     */
    readonly osIs?: Array<string> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof OsisRuleListItem
     */
    readonly fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {boolean}
     * @memberof OsisRuleListItem
     */
    allowEdit?: boolean;
}

export function OsisRuleListItemFromJSON(json: any): OsisRuleListItem {
    return OsisRuleListItemFromJSONTyped(json, false);
}

export function OsisRuleListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'marketingCarriers': !exists(json, 'marketingCarriers') ? undefined : (json['marketingCarriers'] === null ? null : (json['marketingCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'osIs': !exists(json, 'osIs') ? undefined : json['osIs'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function OsisRuleListItemToJSON(value?: OsisRuleListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'state': value.state,
        'description': value.description,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'allowEdit': value.allowEdit,
    };
}


